import { render, staticRenderFns } from "./analyticsOfficialFocus.vue?vue&type=template&id=a666d048"
import script from "./analyticsOfficialFocus.vue?vue&type=script&lang=js"
export * from "./analyticsOfficialFocus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports